import React from 'react';
import { CallToAction } from '../../commonTypes/links';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { PrimaryCta } from '../Cta';
import { Grid } from '../Grid/styles';
import { ctaBannerGridItemProps } from './layout';
import {
  CtaBannerContainer,
  CtaBannerGridItem,
  CtaWrapper,
  Heading,
  StyledSecondaryCta,
  Subheading,
  TextWrapper,
} from './styles';

export type CtaBannerProps = {
  primaryCta?: CallToAction;
  secondaryCta?: CallToAction;
  heading: string;
  subheading?: string;
} & ComponentProps;

const CtaBanner: React.FC<CtaBannerProps> = ({
  primaryCta,
  secondaryCta,
  heading,
  subheading,
  ...props
}) => (
  <CtaBannerContainer {...componentProps(props)}>
    <Grid>
      <CtaBannerGridItem {...ctaBannerGridItemProps} subheading={subheading} focusable>
        <TextWrapper
          twoCtas={secondaryCta !== undefined && primaryCta !== undefined}
          subheading={subheading}>
          <Heading>{heading}</Heading>
          {subheading && <Subheading>{subheading}</Subheading>}
        </TextWrapper>
        <CtaWrapper>
          {primaryCta && <PrimaryCta cta={primaryCta} />}
          {secondaryCta && <StyledSecondaryCta background="light" cta={secondaryCta} />}
        </CtaWrapper>
      </CtaBannerGridItem>
    </Grid>
  </CtaBannerContainer>
);

export default applyComponentTheme(CtaBanner, 'CtaBanner');
